import { all } from 'redux-saga/effects';

/** IMPORT SAGA */
import estoquePostoMonitor from './estoquePostoMonitor/sagas';
import usuarios from './usuarios/sagas';
import padroes from './padroes/sagas';
import mensagensTCAGeral from './mensagensTCAGeral/sagas';
import veiculoMensagemTCA from './veiculoMensagemTCA/sagas';
import msgtcaPostoLoco from './msgtcaPostoLoco/sagas';
import msgtcaPosto from './msgtcaPosto/sagas';
import vazaoEquipamentosBicos from './vazaoEquipamentosBicos/sagas';
import modeloEquipamento from './modeloEquipamento/sagas';
import auth from './auth/sagas';
import dialog from './dialog/sagas';
import drawer from './drawer/sagas';
import hooks from './hooks/sagas';
import language from './language/sagas';
import user from './user/sagas';
import usuario from './usuario/sagas';
import alarmeSistema from './alarmeSistema/sagas';
import alarmesSistemas from './alarmesSistemas/sagas';
import abastecimentoA2VF from './abastecimentoA2VF/sagas';
import telatransmitecentral from './telatransmitecentral/sagas';
import servicedlgrelestoque from './servicedlgrelestoque/sagas';
import descargaDetalhe from './descargaDetalhe/sagas';
import estoqueproduto from './estoqueproduto/sagas';
import vazaoPosto from './vazaoPosto/sagas';
import DlgRelPosto from './DlgRelPosto/sagas';
import vtCertificados from './vtCertificados/sagas';
import apuracaoInventario from './apuracaoInventario/sagas';
import equipamento from './equipamento/sagas';
import manutConsultCorrecoes from './manutConsultCorrecoes/sagas';
import manutExcluirVazamento from './manutExcluirVazamento/sagas';
import manutRetrasmitirUnilog from './manutRetrasmitirUnilog/sagas';
import manutTrocarLocoAbast from './manutTrocarLocoAbast/sagas';
import notasfiscaisrecebidas from './notasFiscaisRecebidas/sagas';

export default function* rootSata() {
  return yield all([
    /** EXPORT SAGA */
estoquePostoMonitor,
    notasfiscaisrecebidas,
    usuarios,
    padroes,
    mensagensTCAGeral,
    veiculoMensagemTCA,
    msgtcaPostoLoco,
    msgtcaPosto,
    vazaoEquipamentosBicos,
    modeloEquipamento,
    auth,
    drawer,
    language,
    dialog,
    hooks,
    user,
    usuario,
    telatransmitecentral,
    servicedlgrelestoque,
    alarmeSistema,
    alarmesSistemas,
    descargaDetalhe,
    estoqueproduto,
    DlgRelPosto,
    vtCertificados,
    abastecimentoA2VF,
    apuracaoInventario,
    vazaoPosto,
    equipamento,
    manutConsultCorrecoes,
    manutExcluirVazamento,
    manutRetrasmitirUnilog,
    manutTrocarLocoAbast,
  ]);
}
